import { SWReactIcons } from "@similarweb/icons";

// Replaces store-analysis-graph-title.html
export const StoreAnalysisGraphTitleTemplate = (props) => {
    const viewData = props?.widgetInstance?.viewData;
    const { tooltip, title, customSubtitle } = viewData;

    return (
        <span className="swHeader-title">
            {title}
            <span
                className="swHeader-tooltip scss-tooltip scss-tooltip--s"
                data-scss-tooltip={tooltip}
            >
                <SWReactIcons
                    className="info-icon-widget-header"
                    iconName="info"
                />
            </span>
            <span className="instore-keywords-widget-subtitle">{customSubtitle}</span>
        </span>
    );
};
